import createIcon from '../../createIcon';

/**
 * @component @name SettingsVoice
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAyMy41SDlWMjEuNUg3VjIzLjVaTTEyIDEyLjVDMTMuNjYgMTIuNSAxNC45OSAxMS4xNiAxNC45OSA5LjVMMTUgMy41QzE1IDEuODQgMTMuNjYgMC41IDEyIDAuNUMxMC4zNCAwLjUgOSAxLjg0IDkgMy41VjkuNUM5IDExLjE2IDEwLjM0IDEyLjUgMTIgMTIuNVpNMTEgMjMuNUgxM1YyMS41SDExVjIzLjVaTTE1IDIzLjVIMTdWMjEuNUgxNVYyMy41Wk0xOSA5LjVIMTcuM0MxNy4zIDEyLjUgMTQuNzYgMTQuNiAxMiAxNC42QzkuMjQgMTQuNiA2LjcgMTIuNSA2LjcgOS41SDVDNSAxMi45MSA3LjcyIDE1LjczIDExIDE2LjIyVjE5LjVIMTNWMTYuMjJDMTYuMjggMTUuNzMgMTkgMTIuOTEgMTkgOS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsVoice = createIcon('SettingsVoice', [
  [
    'path',
    {
      d: 'M7 23.5H9V21.5H7V23.5ZM12 12.5C13.66 12.5 14.99 11.16 14.99 9.5L15 3.5C15 1.84 13.66 0.5 12 0.5C10.34 0.5 9 1.84 9 3.5V9.5C9 11.16 10.34 12.5 12 12.5ZM11 23.5H13V21.5H11V23.5ZM15 23.5H17V21.5H15V23.5ZM19 9.5H17.3C17.3 12.5 14.76 14.6 12 14.6C9.24 14.6 6.7 12.5 6.7 9.5H5C5 12.91 7.72 15.73 11 16.22V19.5H13V16.22C16.28 15.73 19 12.91 19 9.5Z',
      key: '1utgom',
    },
  ],
]);

export default SettingsVoice;
